function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  clipRule: "evenodd",
  d: "M12.282 4.586 5.287 9.401a2.14 2.14 0 0 0-.954 1.763c0 1.776 2.08 2.8 3.578 1.776L13 9.448l5.088 3.492c1.499 1.037 3.579 0 3.579-1.776 0-.703-.36-1.37-.954-1.775l-6.995-4.815a1.287 1.287 0 0 0-1.436.012zM12.282 14.372l-6.995 4.803c-.595.417-.954 1.072-.954 1.776 0 1.775 2.08 2.812 3.578 1.775L13 19.235l5.088 3.491c1.499 1.037 3.579 0 3.579-1.775 0-.704-.36-1.37-.954-1.776l-6.995-4.815a1.287 1.287 0 0 0-1.436.012z",
  stroke: "#004152",
  strokeWidth: 1.5
});

var SvgChevronUpUp = function SvgChevronUpUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronUpUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-up-up.3c140367.svg";
export { ForwardRef as ReactComponent };